"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compileTokenHtml = void 0;
const compileTemplate = require("lodash.template");
const transform_token_html_to_object_1 = require("../transform-token-html-to-object/transform-token-html-to-object");
function compileTokenHtml(html, flippers) {
    const tokenObject = (0, transform_token_html_to_object_1.transformTokenHtmlToObject)(html, flippers);
    return compileTemplate(tokenObject.template)(tokenObject.content);
}
exports.compileTokenHtml = compileTokenHtml;
//# sourceMappingURL=compile.js.map